import Cookies from 'js-cookie';

export default class Modal {
  constructor({ el, isLargeQuery }) {
    this.el = el;
    this.isLargeQuery = isLargeQuery;
    this.closers = Array.from(this.el.querySelectorAll('.closer'));

    // has timer
    this.timer = parseInt(this.el.dataset.timer);
    this.cookieKey = 'june-popup';

    this.init();
  }

  init() {
    this.closers.forEach((closer) => {
      closer.addEventListener('click', (e) => {
        e.preventDefault();

        this.el.classList.remove('active');
        document.body.style.overflow = 'initial';
      });
    });

    if (this.timer && this.timer > 0 && !Cookies.get(this.cookieKey)) {
      setTimeout(() => {
        this.el.classList.add('active');
        document.body.style.overflow = 'hidden';

        Cookies.set(this.cookieKey, 'true', { expires: 1 });
      }, this.timer);
    }
  }
}
